import axios from "axios";
import {REPORT_VIEWER_API_URL} from "../constants/api_routes";
import {getHeader, signOut} from "./user_api";

export const getReportViewerDetails = async (inspectionId,token) => {
    try {
        const response = await axios.get(`${REPORT_VIEWER_API_URL}/detail?inspection_id=${inspectionId}&token=${token}`, {headers: getHeader()});
        return response;
    } catch (e) {
        return {
            message: e.response.data.error,
            status: e.response.status
        };
    }
};

export const getPVReportViewerDetails = async (pvId,token) => {
    try {
        const response = await axios.get(`${REPORT_VIEWER_API_URL}/pvdetail?pv_id=${pvId}&token=${token}`, {headers: getHeader()});
        return response;
    } catch (e) {
        return {
            message: e.response.data.error,
            status: e.response.status
        };
    }
};

export const getReportByIDReportViewer = async (reportId,token) => {
    try {
        const res = await axios.get(`${REPORT_VIEWER_API_URL}/reportdetail?report_id=${reportId}&token=${token}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const validateCSQuery = async (query_id,token) => {
    try {
        const response = await axios.get(`${REPORT_VIEWER_API_URL}/query_validation?query_id=${query_id}&token=${token}`, {headers: getHeader()});
        return response;
    } catch (e) {
        return {
            message: e.response.data.error,
            status: e.response.status
        };
    }
};





// WEBPACK FOOTER //
// ./src/data/report_viewer_api.js